<template>
  <w-column
    class='pt-0 pb-0'
    v-bind="$props"
  >
    <slot name="divider-layout-wrapper">
      <w-divided-in-divider-layout-wrapper :class="{ 'fill-height': fillHeight }">
        <slot />
      </w-divided-in-divider-layout-wrapper>
    </slot>
  </w-column>
</template>

<script>
import WorkColumn from "../grid/WorkColumn";

export default {
  name: "WorkDividedInColumnDivider",
  props: {
    ...WorkColumn.props,
    fillHeight: { type: Boolean, default: true }
  },
}
</script>
